import { render, staticRenderFns } from "./PartnerViewSmall.vue?vue&type=template&id=6ff54f9a&scoped=true"
import script from "./PartnerViewSmall.vue?vue&type=script&lang=js"
export * from "./PartnerViewSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff54f9a",
  null
  
)

export default component.exports